import { render, staticRenderFns } from "./vField.vue?vue&type=template&id=1619417a&"
import script from "./vField.vue?vue&type=script&lang=js&"
export * from "./vField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports